import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="enrolment-form"
export default class extends Controller {
  static targets = ["date"]

  updatePrograms() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    const url = new URL(frame.src)
    url.searchParams.set('enrolment_date', this.dateTarget.value)

    frame.src = url.toString()
  }
}
